var _circle, _circle2, _circle3, _path, _circle4, _circle5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 811 512"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267.3,
    cy: 324.9,
    r: 53.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 324.9,
    r: 53.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.1,
    cy: 324.9,
    r: 53.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8 405h53.4c29.5 0 53.4 23.9 53.4 53.4V485c0 14.7-11.9 26.7-26.7 26.7H27.1C12.4 511.7.4 499.8.4 485v-26.7c.1-29.5 24-53.3 53.4-53.3zM240.6 405H294c29.5 0 53.4 23.9 53.4 53.4V485c0 14.7-11.9 26.7-26.7 26.7H213.9c-14.7 0-26.7-11.9-26.7-26.7v-26.7c0-29.5 23.9-53.3 53.4-53.3zM427.4 405h53.4c29.5 0 53.4 23.9 53.4 53.4V485c0 14.7-11.9 26.7-26.7 26.7H400.7c-14.7 0-26.7-11.9-26.7-26.7v-26.7c0-29.5 23.9-53.3 53.4-53.3zM454.1 138.1H80.5v106.7c-20.6 0-39.2 8-53.4 20.8V126.1c0-22.8 18-41.4 40-41.4h400.3c22.1 0 40 18.6 40 41.4v139.6c-14.2-12.8-32.8-20.8-53.4-20.8V138.1z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.6,
    cy: 196.3,
    r: 41.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 748.3,
    cy: 196.3,
    r: 41.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M580.7 259.2h41.9c23.1 0 41.9 18.8 41.9 41.9v21c0 11.6-9.4 21-21 21h-83.8c-11.6 0-21-9.4-21-21v-21c0-23.2 18.8-41.9 42-41.9zM727.3 259.2h41.9c23.1 0 41.9 18.8 41.9 41.9v21c0 11.6-9.4 21-21 21h-83.8c-11.6 0-21-9.4-21-21v-21c.1-23.2 18.9-41.9 42-41.9zM748.3 49.6H454.9v47.6c-16.2 0-30.8 6.3-41.9 16.4V40.2c0-17.9 14.1-32.5 31.4-32.5h314.3c17.3 0 31.4 14.6 31.4 32.5v109.6c-11.1-10.1-25.8-16.4-41.9-16.4V49.6z"
  })));
}
export default SvgPartners;